<template>

	<div class="row pb--4" @click.stop.prevent="handleClick">
		<div class="col-12 col-xs-12 pt--2">
			<div class="accordion bdr--light-gray accordion--arrows">
				<div class="accordion__item bdr__top--light-gray" data-accordion-type="default"
					v-for="(acc, index) in accordions" :key="acc.title">
					<button :class="{ 'accordion__header--active': acc.display }" :id="'acc' + index"
						@click="acc.display = !acc.display" class="accordion__header txt--md txt--strong">
						{{ acc.title }}
					</button>
					<div class="accordion__content wysiwyg" :aria-labelledby="'acc' + index"
						:class="{ 'accordion__content--active active': acc.display }" v-html="acc.content">
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
export default {
	name: "Content",
	methods: {
		handleClick(e) {
			if (e.target.matches("a")) {
				let url = e.target.href;
				let target = e.target.target == "_blank" ? "_blank" : "_self";
				let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
				var isnativeapp = document.getElementById("isnativeapp");
				if (isnativeapp === undefined || isnativeapp === null) {
					window.open(url, target);
				}
				else {
					if (target == "_blank") {
						let data = { title: '', nodeid: dataId, href: url, target: target };
						window.Native('dataCallback', data);
					}
				}
			}
		},
	},
	data: function () {
		return {
			accordions: [
				{
					display: false,
					title: "About sore throat",
					content: `
					<p>
							Acute pharyngitis is characterised by the rapid onset of sore throat and pharyngeal inflammation (with or without exudate).
					</p>
					<h3 class="txt--lg">
							Bacterial and viral sore throat
					</h3>
					<p>
							Sore throat can be caused by a variety of viral and bacterial pathogens, including group A <em>Streptococcus</em> (GAS), as well as fungal pathogens (<em>Candida</em>). Absence of cough, nasal congestion, and nasal discharge distinguishes bacterial from viral aetiologies. Bacterial pharyngitis is more common in winter (or early spring), while enteroviral infection is more common in the summer and autumn. Generally a self-limited condition with resolution within two weeks.
					</p>
					<p>The goal of treatment of GAS is to prevent acute rheumatic fever, reduce the severity and duration of symptoms, and prevent transmission.</p>
					<p>Acute pharyngitis is generally a self-limited condition with resolution within two weeks</p>

					<h3 class="txt--lg">Tonsillitis</h3>
					<p>Acute tonsillitis is an acute infection of the parenchyma of the palatine tonsils. The clinical distinction between tonsillitis and pharyngitis is unclear in the literature, and the condition is often referred to simply as 'acute sore throat'.</p>
					<p>Reference – <a href="https://bestpractice-bmj-com.knowledge.idm.oclc.org/topics/en-gb/5" target="_blank">BMJ Best Practice</a></p>
					`
				},
				{
					display: false,
					title: "Guidance & actions",
					content: `
					<h3 class="txt--lg">Key guidelines</h3>
						<p>National Institute for Health and Care Excellence and Public Health England (2020) <a href="https://www.nice.org.uk/Media/Default/About/what-we-do/NICE-guidance/antimicrobial%20guidance/summary-antimicrobial-prescribing-guidance.pdf" target="_blank">Summary of antimicrobial prescribing guidance – managing common infections</a></p>
						<p>National Institute for Health and Care Excellence (2018) <a href="https://www.nice.org.uk/guidance/ng84" target="_blank">Sore throat (acute): antimicrobial prescribing</a></p>
						<p>National Institute for Health and Care Excellence (2008) <a href="https://www.nice.org.uk/guidance/CG69" target="_blank">Respiratory tract infections (self-limiting): prescribing antibiotics</a></p>
						<p class="mb--1">National Institute for Health and Care Excellence (2019) <a href="https://www.nice.org.uk/guidance/dg38" target="_blank">Rapid tests for group A streptococcal infections in people with a sore throat</a></p>
						<h3 class="txt--lg">Key actions</h3>
						<ul>
								<li>Steroids and NSAIDS improve symptoms; antibiotics are often indicated in streptococcal pharyngitis, but do not prevent its suppurative complications, like peritonsillar abscess. (<a href="https://www.nice.org.uk/guidance/ng84" target="_blank">NICE 2018 guidance</a>)</li>
								<li>Provide patient information and self-care advice (see below).</li>
								<li>Carefully consider patients with symptom duration longer than 3 days, even though the Centor Score does not apply. While symptoms are not compatible with a diagnosis of acute pharyngitis, these patients require evaluation for suppurative complications (e.g. peritonsillar abscess), or viral infections in adult patients (infectious mononucleosis or acute HIV)</li>
						</ul>
					`
				},
				{
					display: false,
					title: "Efficacy of antibiotics for sore throat (NNT, NNH)",
					content: `
						<p>Recommendations in NICE 2018 guidance highlight the findings from a 2014 Cochrane Review. Based on low to moderate quality evidence, this review found that:</p>
						<p><strong>1.With antibiotics, significantly more people with acute sore throat were symptom free at days 3 and 7 compared with placebo.</strong></p>
						<ul><li>At day 3, 51% were symptom free with antibiotics compared with 34% with placebo (NNT 6 [range 5 to 7]). At day 7, most people in both groups were symptom free (87% versus 82%, NNT 21 [range 14 to 49]).</li></ul>
						<p><strong>2.Overall, antibiotics shortened the duration of symptoms by about 16 hours over 7 days.</strong></p>
						<p><strong>3.Antibiotics are more effective in people with a throat swab positive for GABHS.</strong></p>
						<ul><li>The NNT with antibiotics compared with placebo to prevent 1 person with a negative throat swab having a sore throat on day 3 was 7 (range 5 to 12), with an NNT of about 4 (range 4 to 5) for people with a throat swab positive for GABHS</li></ul>
						<p><strong>4.The overall incidence of suppurative complications, including acute otitis media, acute sinusitis and quinsy (peri-tonsillar abscess), was low.</strong></p>
						<ul>
								<li>This finding was based on data from older studies, mostly conducted in the 1950s. These studies found that antibiotics significantly reduced the incidence of acute otitis media and acute sinusitis within 14 days, and quinsy (peri-tonsillar abscess) within 2 months, compared with placebo. Based on the complication rates from studies conducted after 1975,  the review authors estimated that 200 people would need to be treated with antibiotics to prevent 1 case of acute otitis media.</li>
								<li>Rheumatic fever was reported only in RCTs published before 1961. The incidence has continued to decline in western societies since then. Results from these early studies found that antibiotics reduced acute rheumatic fever by more than two-thirds compared with placebo (low quality evidence).</li>
						</ul>
						<h3 class="txt--lg">
								Harms associated with antibiotic use
						</h3>
						<p><a href="https://www.nice.org.uk/guidance/ng84" target="_blank">NICE 2018 Guidance</a> highlights the following issues about safety of antibiotic use for sore throat:</p>
						<ul>
								<li>Allergic reactions to penicillins occur in 1 to 10% of people and anaphylactic reactions occur in less than 0.05%. People with a history of atopic allergy (for example, asthma, eczema and hay fever) are at a higher risk of anaphylactic reactions to penicillins. People with a history of immediate hypersensitivity to penicillins may also react to cephalosporins and other beta-lactam antibiotics (BNF, November 2017).</li>
								<li>Antibiotic-associated diarrhoea is estimated to occur in 2 to 25% of people taking antibiotics, depending on the antibiotic used (<a href="https://cks.nice.org.uk/topics/diarrhoea-antibiotic-associated/" target="_blank">NICE Clinical Knowledge Summary [CKS]: diarrhoea – antibiotic associated).</a></li>
						</ul>
						<h3 class="txt--lg">Antibiotic resistance</h3>
						<p>
								Every course of antibiotic is likely to result in some emerging resistance which could affect the next choice of antibiotic regimen for that individual, especially if within 3 months of the previous antibiotic.
						</p>
					`
				},
				{
					display: false,
					title: "Patient information & self-care advice",
					content: `
					<p><strong>Key patient information resources</strong></p>
						<p><a href="https://www.nhsinform.scot/illnesses-and-conditions/ears-nose-and-throat/sore-throat" target="_blank">NHS inform – Sore throat</a></p>
						<p><a href="https://www.nhsinform.scot/illnesses-and-conditions/ears-nose-and-throat/tonsillitis" target="_blank">NHS inform - Tonsillitis</a></p>
						<p><a href="https://www.nhsinform.scot/tests-and-treatments/medicines-and-medical-aids/types-of-medicine/antibiotics" target="_blank">NHS inform – Antibiotics</a></p>
						<p><strong>Self-care advice</strong></p>
						<p>(from National Institute for Health and Care Excellence (2018) <a href="https://www.nice.org.uk/guidance/ng84" target="_blank">Sore throat (acute): antimicrobial prescribing</a> )</p>
						<p><strong>General self-care advice for all people with acute sore throat</strong></p>
						<ul>
								<li>Consider paracetamol for pain or fever, or if preferred and suitable, ibuprofen.</li>
								<li>Advise about the adequate intake of fluids.</li>
								<li>Explain that some adults may wish to try medicated lozenges containing either a local anaesthetic, a non-steroidal anti-inflammatory drug (NSAID) or an antiseptic. However, they may only help to reduce pain by a small amount.</li>
								<li>Be aware that NICE guidance found no evidence was found on non-medicated lozenges, mouthwashes, or local anaesthetic mouth spray used on its own.</li>
						</ul>
						<p>
								<strong>Advice for people who are unlikely to benefit from an antibiotic</strong> (<a href="https://www.nice.org.uk/guidance/ng84/chapter/terms-used-in-the-guideline" target="_blank">
										FeverPAIN score
								</a> of 0 or 1, or <a href="https://www.nice.org.uk/guidance/ng84/chapter/terms-used-in-the-guideline" target="_blank">Centor score</a> of 0, 1 or 2):
						</p>
						<ul>
								<li>
										an antibiotic not being needed
								</li>
								<li>seeking medical help if symptoms worsen rapidly or significantly, do not start to improve after 1 week, or the person becomes systemically very unwell.</li>
						</ul>
						<p><strong>Advice for people who may be more likely to benefit from an antibiotic</strong> ( <a href="https://www.nice.org.uk/guidance/ng84/chapter/terms-used-in-the-guideline" target="_blank">FeverPAIN score</a> of 2 or 3)</p>
						<p>When a back-up antibiotic prescription is given, as well as the general self-care advice above, give advice about:</p>

						<ul>
								<li>
										an antibiotic not being needed immediately
								</li>
								<li>
										using the back-up prescription if symptoms do not start to improve within 3 to 5 days or if they worsen rapidly or significantly at any time
								</li>
								<li>seeking medical help if symptoms worsen rapidly or significantly or the person becomes systemically very unwell.</li>
						</ul>
						<p><strong>Advice for people who are most likely to benefit from an antibiotic</strong> (<a href="https://www.nice.org.uk/guidance/ng84/chapter/terms-used-in-the-guideline" target="_blank">FeverPAIN score</a> of 4 or 5, or <a href="https://www.nice.org.uk/guidance/ng84/chapter/terms-used-in-the-guideline" target="_blank">Centor score</a> of 3 or 4)</p>
						<ul>
								<li>When an immediate antibiotic prescription is given, as well as the general self-care advice above, give advice about seeking medical help if symptoms worsen rapidly or significantly or the person becomes systemically very unwell.</li>
						</ul>
					`
				},
				{
					display: false,
					title: "Severe complications",
					content: `
					<p>(<a href="https://gpnotebook.com/" target="_blank">Based on GP Notebook</a>)</p>
					<h3 class="txt--lg">Peritonsillar abscess (Quinsy)</h3>
						<p><strong>Clinical features</strong></p>
						<ul>
								<li>the patient is already suffering from acute tonsillitis</li>
								<li>
										the patient continues to become more ill
								</li>
								<li>
										referred earache is a common feature
								</li>
								<li>
										the patient develops severe dysphagia
								</li>
								<li>trismus is often a feature</li>
						</ul>
						<p>
								<strong>
										On examination
								</strong>
						</p>
						<ul>
								<li>
										the buccal mucosa is dirty and fetor is present
								</li>
								<li>
										the uvula may be very oedematous and displaced downwards and medially by the infected tonsil
								</li>
								<li>the uvula may be so oedematous so as to resemble a white grape</li>
						</ul>
						<h3 class="txt--lg">Scarlet fever</h3>
						<p>
								<strong>
										Clinical features
								</strong>
						</p>
						<ul>
								<li>Fever (usually above 38.3º C/101º F or higher)</li>

								<li>
										Headache, malaise, nausea and vomiting
								</li>

								<li>
										Swollen neck glands
								</li>
								<li>
										Characteristic fine red rash
										<ul>
												<li>
														develops twelve to forty eight hours after the onset of these symptoms
												</li>
												<li>
														first appears on the chest and stomach and later covers the entire body and limbs and consists of many small papules on diffuse erythema that blanches on pressure.
												</li>
												<li>
														often more marked over the skinfolds where transverse lines containing tiny petichae may be seen
												</li>
												<li>
														the rash lasts for a period of two to three days, after which desquamation occurs that is most prominent on the soles of the feet and the palms of the hands
												</li>
										</ul>
								</li>
								<li>
										Examination of the throat generally reveals that the pharynx is diffusely reddened, with enlarged and red tonsils covered with a white exudate.
								</li>
								<li>
										Tongue may be initially furred with enlarged papillae - an appearance described as a 'white strawberry tongue', lost after two or three days to become strawberry tongue.
								</li>
								<li>
										Usually there is enlargement of regional lymph nodes
								</li>
								<li>
										Flushed red face with paleness around the mouth
								</li>
						</ul>
						<h3 class="txt--lg">Acute rheumatic fever</h3>
						<p><strong>Clinical features</strong></p>
						<ul>
								<li>
										patients are 5 to 15 years old
								</li>
								<li>
										streptococcal infection is a prerequisite for subsequent development of rheumatic fever
								</li>
								<li>
										the latent period following a streptococcal infection is 2 to 6 weeks
								</li>
								<li>
										typically the patient will have migratory polyarthritis with a low-grade fever
								</li>
								<li>
										50-75% of children will develop acute carditis; in adults this figure is only 35%
								</li>
								<li>
										myocarditis causes arrythmias, usually atrial fibrillation, and a prolonged P-R interval
								</li>
								<li>
										cardiac dilatation may occur, resulting in murmurs of valvular insufficiency, mitral most commonly, then aortic, then tricuspid
								</li>
								<li>
										valvulitis is marked by the systolic murmur of mitral regurgitation and the diastolic murmur of aortic regurgitation
								</li>
								<li>
										subcutaneous nodules are a rare feature
								</li>
						</ul>
						<p><strong>Other abnormal findings on cardiovascular examination include</strong></p>
						<ul>
								<li>
										sinus tachycardia
								</li>
								<li>
										raised jugular venous pressure, due to heart failure which is now rare
								</li>
								<li>
										a Carey-Coombs murmur
								</li>
						</ul>
					`
				},
				{
					display: true,
					title: "Regulatory Information",
					content: `
						<p>
						<strong>Product Name: </strong>Calculator Suite <br>
						<strong>Calculator Name: </strong>FeverPAIN Score for Streptococcal Pharyngitis<br>
						<strong>Calculator Version: </strong> v2.1.0
						</p>  
						<div class="row">
						<div class="col-xs-4 col-lg-2">
							<img src="/img/cemark/shii.png" alt="InnoScot Health"/>
						</div>
						<div class="col-xs-8 col-lg-10">
							<p>
                  Innoscot Health<br>
									Suite 23, The Pentagon Centre<br>
									36 Washington Street<br>
									Glasgow<br>
									G3 8AZ
                </p>
						</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<p>
								<img src="/img/cemark/ukca.png" alt="UK Conformity Assessed"/>
								<!-- <img src="/img/cemark/ce.png" alt="CE marking"/> -->
								</p>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/warning.png" alt="InnoScot Health"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
								<strong>Calculators are <u>not</u> intended to be used by members of the public as a substitute for professional advice.</strong>
								</p>
							</div>
						</div>
						
						<div class="row">
							<div class="col-xs-4 col-lg-2">
								<img src="/img/cemark/info.png" alt="More Information on Right Decision"/>
							</div>
							<div class="col-xs-8 col-lg-10">
								<p>
									<a href="https://rightdecision.scot.nhs.uk/quality-assurance-and-regulation/calculator-suite-instructions-for-use.pdf" target="_blank">Instructions for use</a>
								</p>
							</div>
						</div>
					`
				}
			]
		}
	}
};
</script>
